import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router';
import { oauthClient } from '../../apis/OAuthClient';
import { useAppContext } from '../../contexts/AppContext';
import { useUserHook } from '../../hooks/UserHook';
import { ApiPortalBackend } from '../../apis/ApiPortalBackend';

export default function LoginRegister() {
  const { t } = useTranslation('platformPages');
  const context = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [, userService] = useUserHook();

  const queryParams = new URLSearchParams(location.search);
  const codeparam = queryParams.get('code');

  const checkUserLoggedIn = async () => {
    const isValid = await oauthClient.validateTokenWithSecondService();
    if (!isValid) return;

    const user = await ApiPortalBackend.GetMyself();
    if (user == null) return;

    userService.forceFetchUser().then(() => {
      context.setShowSidebar(true);
      context.setShowTopbar(true);
      navigate('/chat');
    }).catch(() => {});
  };

  useEffect(() => {
    context.setShowSidebar(false);
    context.setShowTopbar(false);
  }, []);

  useEffect(() => {
    document.title = 'Login';
    if (codeparam) {
      oauthClient.handleCallback();
      return;
    }

    checkUserLoggedIn();
  }, []);

  const handleLoginWithSengi = () => oauthClient.login();
  const handleRegisterWithSengi = () => oauthClient.register();

  return (
    <div className='container p-5 bg-dark text-white' style={{ margin: 'auto', display: 'flex', width: '300px' }}>
      <form className='form-group'>
        <h1 className='text-center'>{t('login.title')}</h1>
        <div className='margin-top-20 margin-bottom-20 padding-top-40'>
          <input
            className='btn btn-primary btn-block margin-bottom-20 login-register-button'
            type='button'
            value={t('login.loginButton')}
            onClick={handleLoginWithSengi}
          />
          <input
            className='btn btn-primary btn-block login-register-button'
            type='button'
            value={t('login.registerButton')}
            onClick={handleRegisterWithSengi}
          />
        </div>
        {/* § 312k BGB: Kündigungsbutton muss auch ohne Login erreichbar sein */}
        <div className='text-center small mt-3'>
          <Link to='/impressum' className='text-secondary'>{t('login.impressum')}</Link>
          <span className='mx-2 text-secondary'>·</span>
          <Link to='/terms' className='text-secondary'>{t('login.terms')}</Link>
          <span className='mx-2 text-secondary'>·</span>
          <Link to='/kuendigung' className='text-secondary'>{t('login.cancelContracts')}</Link>
        </div>
      </form>
    </div>
  );
}
